import { render, staticRenderFns } from "./ReportOrderSumsPerCustomerPage.vue?vue&type=template&id=7a6f5cf4&scoped=true"
import script from "./ReportOrderSumsPerCustomerPage.vue?vue&type=script&lang=js"
export * from "./ReportOrderSumsPerCustomerPage.vue?vue&type=script&lang=js"
import style0 from "./ReportOrderSumsPerCustomerPage.vue?vue&type=style&index=0&id=7a6f5cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f5cf4",
  null
  
)

export default component.exports